import { useEffect, useState } from "react";
import TopBar from "../components/TopBar";
import { fetchQuotes, fetchUsers } from "../utils/apiHelpers";
import { Box, TextField, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../theme";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import api from "../utils/api";

function Quotes() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [quotes, setQuotes] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [users, setUsers] = useState([]);

  const [fieldValues, setFieldValues] = useState({
    authorId: '',
    quote: ''
  })

  useEffect(() => {
    fetchQuotes()
      .then(data => {
        setQuotes(data.sort((a, b) => new Date(b.date) - new Date(a.date)));
        console.log(data);
      })
      .catch(err => console.log(err));
    fetchUsers()
      .then(data => {
        setUsers(data);
      })
      .catch(err => console.log(err));
  }, []);

  async function handleQuoteCreation() {
      const quote = {
        user: selectedUser,
        quote: fieldValues.quote
      };
      console.log(selectedUser);
      console.log(quote);
      try {
          await api.post('/add_quote', quote);
          fetchQuotes()
            .then(data => {
              setQuotes(data.sort((a, b) => new Date(b.date) - new Date(a.date)));
              setFieldValues({ authorId: '', quote: ''});
              setSelectedUser('');
            })
            .catch(err => console.log(err));
      } catch (err) {
          console.log(err)
      }
  }

  return (
    <div>
      <TopBar/>
      <Typography
        variant="h2"
        color={colors.ceriseAccent[900]}
        fontWeight="medium" 
        sx={{m : "50px 0 10px 30px" }}
        >
        Citat
      </Typography>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <TextField
          label="Fyll i ett citat"
          rows={3}
          multiline={true}
          variant="outlined"
          value={fieldValues.quote}
          onChange={(e) => setFieldValues({...fieldValues, quote: e.target.value})}
          sx={{m: "10px 0 0 0", width: "90%"}}
          >
        </TextField>
        <Box display="flex" width="90%">
          <FormControl sx={{flexGrow: 1, m: "10px 0 0 0"}}>
            <InputLabel id="demo-simple-select-label">Drifvare</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedUser}
              label="Drifvare"
              onChange={(e) => setSelectedUser(e.target.value)}
            >
              {
                users.map((user) => (
                  <MenuItem key={user.id} value={user}>
                    {user.display_name}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
          {/* Add product button */}
          <Button
              variant="outlined"
              disabled={!fieldValues.quote || !selectedUser}
              sx={{
                backgroundColor: colors.ceriseAccent[100],
                m: "10px 0 0 10px",
                "&.Mui-disabled": {
                  background: colors.gray[700],
                  color: colors.gray[300]
                }
              }}
              onClick={handleQuoteCreation}
          >
            Skicka in
          </Button>
        </Box>
      </Box>
      <Typography
        variant="h4"
        color={colors.gray[100]}
        fontWeight="medium" 
        sx={{m : "50px 0 10px 30px" }}
        >
        Tidigare citat
      </Typography>
      {
        quotes !== undefined ?
        quotes.map(quote => (
          <Box 
            key={quote.id}
            display="flex" 
            flexDirection="column" 
            justifyContent="flex-start"
            padding="10px"
            sx={{ m: "0 30px 20px 30px", backgroundColor: colors.gray[800], borderRadius: "4px"}}
          >
            <Typography
              variant="h4"
              color={colors.gray[100]}
              fontWeight="medium" 
            >
              {quote.quote}
            </Typography>
            <Typography
              variant="h6"
              color={colors.gray[100]}
              fontWeight="medium" 
            >
              - {quote.display_name}
            </Typography>
            <Typography
              variant="h6"
              color={colors.gray[400]}
              fontWeight="regular" 
            >
              {new Date(quote.date).toLocaleDateString("sv-SE", {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </Typography>
          </Box>
        )) : null
      }
    </div>
  )
}

export default Quotes;